import { useState, useEffect } from "react";
import { toast } from "sonner";
import { Lock, Loader2 } from "lucide-react";
import AdminDashboard from "./AdminDashboard";
import { login, fetchMe, getToken, clearToken, formatApiError } from "../lib/adminApi";

export default function Admin() {
  const [user, setUser] = useState(null);
  const [checking, setChecking] = useState(true);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!getToken()) {
      setChecking(false);
      return;
    }
    fetchMe()
      .then(setUser)
      .catch(() => clearToken())
      .finally(() => setChecking(false));
  }, []);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const u = await login(email, password);
      setUser(u);
      toast.success("Accesso effettuato.");
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  if (checking) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-[#f0ead9]">
        <Loader2 className="animate-spin text-[#c0442b]" />
      </div>
    );
  }

  if (user) {
    return <AdminDashboard user={user} onLogout={() => setUser(null)} />;
  }

  const inputCls =
    "w-full border-0 border-b border-[#16181a]/25 bg-transparent px-0 py-3 font-body text-base text-[#16181a] placeholder:text-[#8a8578] focus:border-[#c0442b] focus:outline-none";

  return (
    <div className="flex min-h-screen items-center justify-center bg-[#f0ead9] px-6">
      <div className="w-full max-w-sm">
        <div className="mb-10 text-left">
          <div className="mb-6 flex h-11 w-11 items-center justify-center border border-[#16181a]/20">
            <Lock size={18} className="text-[#c0442b]" />
          </div>
          <p className="font-display text-3xl text-[#16181a]">
            Gianni Ragone<span className="text-[#c0442b]">.</span>
          </p>
          <p className="mt-2 font-body text-xs uppercase tracking-widest text-[#6e6a64]">
            Area riservata
          </p>
        </div>
        <form data-testid="admin-login-form" onSubmit={submit} className="flex flex-col gap-6">
          <input
            data-testid="login-email"
            type="email"
            placeholder="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className={inputCls}
          />
          <input
            data-testid="login-password"
            type="password"
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className={inputCls}
          />
          <button
            data-testid="login-submit"
            type="submit"
            disabled={loading}
            className="mt-2 flex items-center justify-center gap-2 bg-[#16181a] px-6 py-3 font-body text-sm font-semibold uppercase tracking-widest text-[#f0ead9] transition-colors duration-300 hover:bg-[#c0442b] disabled:opacity-60"
          >
            {loading && <Loader2 size={16} className="animate-spin" />}
            {loading ? "Accesso..." : "Accedi"}
          </button>
        </form>
      </div>
    </div>
  );
}
